import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlowPulseComponent } from './glow-pulse/glow-pulse.component';

@NgModule({
  declarations: [],
  imports: [CommonModule, GlowPulseComponent],
  exports: [GlowPulseComponent],
})
export class GlowPulseModule {}
